var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TypeAndRate } from "./TypeAndRate";
export class VatRateTypeSetting {
  constructor(_data) {
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "TypeRateOptions");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof VatRateTypeSetting
     */
    __publicField(this, "$type", "V1.VatRateTypes.VatRateTypeSetting");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CountryCode = _data["CountryCode"];
      if (_data["TypeRateOptions"] && _data["TypeRateOptions"].constructor === Array) {
        this.TypeRateOptions = [];
        for (let item of _data["TypeRateOptions"]) {
          const typeRateOptions_ = new TypeAndRate();
          this.TypeRateOptions.push(typeRateOptions_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CountryCode"] = this.CountryCode;
    if (this.TypeRateOptions && this.TypeRateOptions.constructor === Array) {
      _data["TypeRateOptions"] = [];
      for (let item of this.TypeRateOptions) {
        _data["TypeRateOptions"].push(item.toJSON());
      }
    }
    return _data;
  }
}
